import React, { Fragment, useState, useEffect } from "react";
import Layout from "../core/Layout";
import { Link } from "react-router-dom";
import moment from "moment";
import axios from 'axios';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Pagination from "react-js-pagination";
import Loader from "../frontpage/Loader";
import firebase from 'firebase/compat/app';
import 'firebase/compat/storage';

const ListBill = () => {
    const [expenses, setExpenses] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [activePage, setActivePage] = useState(1);
    const itemsPerPage = 10;

    
    const[formData1, setFormData1]= useState({
        userId:"",
        HospitalName:"",
      })
  
      const[HospitalName,setHospitalName]=useState("");
  
      useEffect(()=>{
        const unsubscribe = firebase.auth().onAuthStateChanged(async (currentUser) => {
          if (currentUser) {
            const userId = currentUser.uid;
    
            setFormData1((prevData) => ({
              ...prevData,
              userId: userId,
              HospitalName: HospitalName,
            }));
    
            try {
              const response = await axios.get(
                `https://us-central1-hospital-management-syst-7e35d.cloudfunctions.net/api/getHospitalName/${userId}`
              );
              const addressData = response.data;
              setFormData1((prevData) => ({
                ...prevData,
                HospitalName: addressData.HospitalName || " ",
                HospitalId: addressData.HospitalId || " ",
              }));
            } catch (error) {
              console.error("Error fetching user data:", error);
             
            } finally {
              
            }
          } else {
           
          }
        });
    
        return () => unsubscribe();
      }, []);

      const hospitalId=formData1.HospitalId;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get("https://us-central1-hospital-management-syst-7e35d.cloudfunctions.net/api/bills/single",{
                    params: {hospitalId}
                });
                setExpenses(response.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        if(hospitalId){
        fetchData();
        }
    }, [hospitalId]);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const handlePageChange = (pageNumber) => {
        setActivePage(pageNumber);
    };

    const filteredExpenses = expenses.filter(expense =>
        String(expense.patientId).toLowerCase().includes(searchQuery.toLowerCase()) ||
        String(expense.invoice).toLowerCase().includes(searchQuery.toLowerCase()) ||
        String(expense.patientName).toLowerCase().includes(searchQuery.toLowerCase())
    );
    
    

    filteredExpenses.sort((a, b) => a.invoice - b.invoice);

    const indexOfLastItem = activePage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredExpenses.slice(indexOfFirstItem, indexOfLastItem);
    
    const [bill, setBill] = useState([]);

    const handleDelete = async (invoiceNumber) => {
        console.log("invoiceNumber is:", invoiceNumber);
        try {
            await axios.delete(`https://us-central1-hospital-management-syst-7e35d.cloudfunctions.net/api/delete-bill/${invoiceNumber}`);
            // After successful deletion, refresh the list
            setExpenses(expenses.filter(item => item.invoice !== invoiceNumber));
        } catch (error) {
            console.error("Error deleting data:", error);
        }
    };

    return (
        <Layout
            title="Profile"
            description="list treatment categories"
            className="container-fluid"
        ><br></br>
        <Loader/>
            <h1 className="mt-4 color-bright">Generated Bill</h1><br></br><br></br>
            <div className="input-group mb-4" style={{ width: "40%" }}>
                <input
                    type="text"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={handleSearch}
                    className="form-control"
                />
                <div className="input-group-append">
                    <span className="input-group-text">
                        <i className="fas fa-search"></i>
                    </span>
                </div>
            </div>
            {filteredExpenses.length === 0 ? (
                <div className="tbl-header">
                    <table cellpadding="0" cellspacing="0" border="0">
                        <thead>
                            <tr>
                                <th scope="col">Invoice Number</th>
                                <th scope="col">Patient Id</th>
                                <th scope="col">Patient Name</th>
                                <th scope="col">Amount</th>
                               
                                <th scope="col">View</th>
                                <th scope="col">Edit</th>
                                <th scope="col">Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="text-center" colSpan="5">No Data</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            ) : (
                <>
                <Pagination
                activePage={activePage}
                itemsCountPerPage={itemsPerPage}
                totalItemsCount={filteredExpenses.length}
                pageRangeDisplayed={5}
                onChange={handlePageChange}
                itemClass="page-item"
                linkClass="page-link"
            />
                    <div className="tbl-header table-responsive">
                        <table id="listPatients" cellpadding="0" cellspacing="0" border="0">
                            <thead>
                                <tr>
                                    <th scope="col">Invoice Number</th>
                                    <th scope="col">Patient Id</th>
                                    <th scope="col">Patient Name</th>
                                    <th scope="col">Amount</th>
                                    <th scope="col">View</th>
                                    <th scope="col">Edit</th>
                                    <th scope="col">Delete</th>
                                </tr>
                            </thead>
                       
                            <tbody>
                                {currentItems.map((expense, i) => (
                                    <tr key={i}>
                                        <Fragment>
                                            <td>{expense.invoice}</td>
                                            <td>{expense.patientId}</td>
                                            <td>{expense.patientName}</td>
                                            <td>{expense.total}</td>
                                            <td>
                                                <a href={expense.url} target="_blank" rel="noopener noreferrer">
                                                    View Invoice
                                                </a>
                                            </td>
                                            <td>
                                                <Link to={`/update-bill/${expense.invoice}`}
                                                        className="btn btn-link"
                                            
                                                    >
                                                        <i className="fas fa-edit"></i>
                                                    </Link>
                                            </td>
                                            <td>
                                                <button
                                                        className="btn btn-link"
                                                        onClick={() => handleDelete(expense.invoice)}
                                                    >
                                                        <i className="fas fa-trash"></i> {/* Delete icon */}
                                                    </button>
                                            </td>
                                        </Fragment>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
           
        </Layout>
    );
};

export default ListBill;
